module.exports = __webpack_public_path__ + "img/hugo3.3f109436.jpg";